import { AWSRegion, AWSConfig, CognitoIdentityServiceProvider } from './awsSDK';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import config from '../config';
import ConsoleLog from './../hoc/ConsoleLog/ConsoleLog';

const data = {
  identityPool: config.cognito.identityPool,
  userPool: {
    UserPoolId: config.cognito.userPool,
    ClientId: config.cognito.clientId
  }
};

const getUserPool = () => new CognitoUserPool(data.userPool);

// Gets a cognito user
const getCognitoUser = user => {
  const pool = getUserPool()
  return pool.getCurrentUser()
};

// The primary method for verifying/starting a CoginotID session
const verifySession = () => {
  const poolUrl = `cognito-idp.${AWSRegion}.amazonaws.com/${
    data.userPool.UserPoolId
  }`
  /* Note - I'm skipping the basic auth step since I already have the accessToken and jwtToken stored locally
  thanks to Cognito Auth */

  /* You don't have to do this, but I am so I can get the user's name from the parsed JWT token so I don't have
  to call getUserAttributes after the session as been started. */
  const cognitoUser = getCognitoUser();
  //ConsoleLog('cognitoUser', cognitoUser);
  let name;

  /** Get a new session and set it in the AWS config */
  const cognitoSession = cognitoUser.getSession((err, session) => {
    if (session) {
      const refresh_token = session.getRefreshToken();

      if (AWSConfig.credentials && AWSConfig.credentials.needsRefresh()) {
        cognitoUser.refreshSession(refresh_token, (err, session) => {
          if(err) { ConsoleLog('refresh session',err); } 
          else {
            AWSConfig.credentials.params.Logins['cognito-idp.' + config.cognito.region + '.amazonaws.com/' + config.cognito.userPool]  = session.getIdToken().getJwtToken();
            AWSConfig.credentials.refresh((err)=> {
              if(err)  { ConsoleLog('refresh credentials error',err); }
              else{
                // ConsoleLog("TOKEN SUCCESSFULLY UPDATED");
              }
            });
          }
        });
        return cognitoUser;
      } else {
        return cognitoUser;
      }
    }
  });
  return cognitoSession;  
}

const registerUser = (attributes, groupName) => {
  const password = 'Galaxy@123';
  let params = {
    UserPoolId: data.userPool.UserPoolId,
    Username: attributes.email,
    DesiredDeliveryMediums: ['EMAIL'],
    ForceAliasCreation: false,
    //MessageAction: 'SUPPRESS',
    TemporaryPassword: password,
    UserAttributes: mkAttrList(attributes),
    ValidationData: [
    {
      Name: 'email',
      Value: ''
    }]
  };
  
  let userPool = new CognitoIdentityServiceProvider({ apiVersion: '2016-11-25'});

  return new Promise((resolve, reject) => 
    userPool.adminGetUser({ UserPoolId: data.userPool.UserPoolId, Username: attributes.email }, (err, res) => {
      if (err) {
        userPool.adminCreateUser(params, (err, result) => {
          if (err) {
            reject(err.message);
          } else {
            let groupParams = {
              UserPoolId: data.userPool.UserPoolId,
              Username: attributes.email,
              GroupName: groupName,
            };
            userPool.adminAddUserToGroup(groupParams, (err, data) => {
              if (err) {
                ConsoleLog(err, err.stack); // an error occurred
                reject(err.message);
              } else {
                resolve(data);
              } 
            });
          }
        });
      } else {
        resolve(res);
      }   
    }));
  }

  /**
   * convert an attribute dictionary to an attribute list
   * @param {object} attributes - a dictionary of attributes
   * @return {array} AWS expected attribute list
  */
  const mkAttrList = attributes =>
    Object.keys(attributes).map(key => ({
      Name: key,
      Value: attributes[key],
    })
  );

const cognitoId = {
  getUserPool,
  getCognitoUser,
  verifySession,
  registerUser
}

export default cognitoId;


// WEBPACK FOOTER //
// ./src/lib/cognitoId.js